import { useMutation } from 'react-query';
import { bankValidation } from '~/api/application';

export const useBankValidation = () => {
  return useMutation(bankValidation, {
    onSuccess: (res) => {
      console.log('r2323232esres', res);
      return res;
    },
  });
};
